import React from "react";
import classnames from "classnames";
import * as Commons from "oc-commons/Commons";
import { MAuswahlwert } from "../../../metamodell";
import { Auswahl, logUserAuswahl } from "../Auswahl";

export function Farbmenuselect({
  auswahlwerte,
  value,
  onChange,
  className,
}: {
  auswahlwerte: MAuswahlwert[];
  value: MAuswahlwert;
  onChange: (value: MAuswahlwert) => void;
  className?: string;
}) {
  const füllungAuswahlwerte = auswahlwerte.filter((fa) => fa.Typinfo != "Sonderfarbe");
  const füllungAuswahlwerteSonderfarbe = auswahlwerte.filter((fa) => fa.Typinfo == "Sonderfarbe");
  const hasSonderfarben = !Commons.isEmpty(füllungAuswahlwerteSonderfarbe);
  const sonderfarbenAuswahlwert = APP.richMetadata.findAuswahlwert("Sonderfarben");

  return (
    <>
      {füllungAuswahlwerte
        .filter((auswahlwert) => !auswahlwert.Gesperrt)
        .map((auswahlwert) => (
          <FarbAuswahl
            key={auswahlwert.Key}
            auswahlwert={auswahlwert}
            selected={value == auswahlwert}
            onChange={onChange}
            className={className}
          />
        ))}

      {hasSonderfarben && <div className="separator" />}

      {_.includes(füllungAuswahlwerteSonderfarbe, value) && (
        <FarbAuswahl
          auswahlwert={value}
          selected={true}
          onChange={onChange}
          className={className}
        />
      )}

      {hasSonderfarben && (
        <div className="sonderfarben-auswahl-wrapper">
          <FarbAuswahl
            auswahlwert={sonderfarbenAuswahlwert}
            selected={false}
            onChange={() => {}}
            className={className}
            prefix={füllungAuswahlwerteSonderfarbe[0].Prefix}
          />
          <Auswahl
            Key="Füllung"
            value={value}
            showHeadline={false}
            placeholder={"Sonderfarben"}
            auswahlwerte={füllungAuswahlwerteSonderfarbe}
            customClassPortal="sonderfarben-auswahl"
            onChange={onChange}
          />
        </div>
      )}
    </>
  );
}

function FarbAuswahl({
  auswahlwert,
  selected,
  onChange,
  className,
  prefix,
}: {
  auswahlwert: MAuswahlwert;
  selected: boolean;
  onChange: (value: MAuswahlwert) => void;
  className?: string;
  prefix?: string;
}) {
  const handleActivate = () => {
    onChange(auswahlwert);
    logUserAuswahl(auswahlwert);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleActivate();
    }
  };

  const ariaLabel = auswahlwert.AriaText || auswahlwert.Name;

  return (
    <div
      key={auswahlwert.Key}
      title={auswahlwert.Name}
      className={classnames("farbe-with-label", selected && "is-selected")}
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="radio"
      aria-checked={selected}
      aria-label={prefix ? `${prefix} ${ariaLabel}` : ariaLabel}
    >
      <div
        className={classnames(className, selected && "selected")}
        style={{ backgroundImage: `url(${auswahlwert.Auswahlbild})` }}
      />
      <div className="text-container">
        <div className="prefix">{prefix ?? auswahlwert?.Prefix}</div>
        <div className="label">
          {Commons.isEmpty(auswahlwert.Bezeichnung) ? auswahlwert.Name : auswahlwert.Bezeichnung}
        </div>
      </div>
    </div>
  );
}
